<template>
<div class="video-list-container">

    <div class="video-list">
      <div class="video-item"  v-for="(videoItem,index) in videoList" :key="index" @click="gotoWeb(videoItem.enrollId,index+1)">
        <div class="video-ranking">
          <div class="ranking">{{index+1}}</div>
        </div>
        <div class="video-img">
          <div class="video-img-bg">
            <video :src="getImageUrl(videoItem.videoFileUri)">
            </video>
            <div class="coverage">
              <img src="../../assets/images/activity/uploadVideo/video-list-play.png">
            </div>
          </div>

        </div>
        <div class="video-info">
          <div class="video-ws-name">{{videoItem.workshopName}}</div>
          <div :class=" videoItem.supportCount>9999 ? 'supportCount1' : 'supportCount' ">
            <img src="../../assets/images/activity/uploadVideo/video-like.png" >
            {{videoItem.supportCount ? videoItem.supportCount : 0 }}
          </div>
        </div>
      </div>
    </div>

</div>
</template>

<script>
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      videoList: [
      ]
    }
  },
  created () {
    this.getVideoList()
  },
  methods: {
    async getVideoList () {
      let { data } = await activityApi.getVideoEnrollList()
      this.videoList = data.resultData.videoList
    },
    getImageUrl (videoFileUri) {
      return commonUtils.getImageUrl(videoFileUri)
    },
    gotoWeb (enrollId, ranking) {
      // this.$router.push({ path: '/activity/video-enroll/info', query: { enrollId: enrollId, ranking: ranking, type: '0' } })
      this.$router.push({ path: '/activity/video-enroll/info', query: { enrollId: enrollId, ranking: ranking, type: '1' } })
    }
  }
}
</script>

<style lang='less' scoped>
.video-list-container{
  height: 100vh;
  width: 100vw;
  background-image: url('../../assets/images/activity/uploadVideo/video-list-bgtop.png'),url('../../assets/images/activity/uploadVideo/video-list-bgbottom.png'),url('../../assets/images/activity/uploadVideo/video-list-bgmiddle.png');
  background-position: top, bottom center;
  background-repeat: no-repeat, no-repeat,repeat;
  background-size: 100% ,100% ;
  overflow: hidden;
}
.video-list{
  position: relative;
  top: 285px;
  width: 85vw;
  height: calc(95vh - 278px);
  left: 7vw;
  overflow-y:auto;
  overflow-x:hidden;
}
.video-item{
  height: 60px;
  width: 100%;
  color: white;
  display: flex;
}
.video-ranking{
  width: 40px;
  height: 100%;
  background-image: url('../../assets/images/activity/uploadVideo/video-num.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 24px 24px ;
  text-align: center;
  line-height: 60px;
}
.video-img{
  width: 25vw;
  height: 60px;
  background-image: url('../../assets/images/activity/uploadVideo/video-bg1.png');
  background-repeat: no-repeat;
  background-size: 82px 55px ;
  .video-img-bg{
    position: relative;
    top: 4.3px;
    background-color: rgba(240, 248, 255, 0.158);
    width: 19.5vw;
    height: 46.5px;
    left: 1.1vw;
    overflow: hidden;
    border-radius: 8px;
  }
  video{
    border-radius: 8px;
    width: 20vw;
  }
  .coverage{
    position: absolute;
    top: 0px;
    width: 19.5vw;
    height:  46.5px;
    background-color: rgba(0, 0, 0, 0.527);
    z-index: 99;
    text-align: center;
    }
    img{
      position: relative;
      top: 12px;
      width: 20px;
      opacity: 0.8;
    }
}
.video-info{
  position: relative;
  .video-ws-name{
    margin-top: 5px;
    line-height: 18px;
    width: calc(59vw - 40px  );
    height: 40px;
    //width: 150px;
  }
  img{
      width: 14px;
    }
  .supportCount{
    position: absolute;
    top: 37px;
    left: 125px;
  }
  .supportCount1{
    position: absolute;
    top: 37px;
    left: 123px;
  }
}
.video-cover{
  width: 25vw;
  height: 25vw;
  background-color: black;
}
.cover-img{
  width: 10vw;
  height: 10vw;
  padding: 7.5vw;
  background-color: black;
}
</style>
